<div *ngIf="text" class="warning-container recog-body14" [class.error-container]="variant === 'error'"
    [attr.role]="variant === 'error' ? 'alert' : 'status'" aria-live="polite">
    <i class="uil uil-exclamation-triangle warning-icon"></i>
    <span>{{ text | t }}</span>
    <button *ngIf="actionLabel" type="button" class="notice-action" [disabled]="busy" [attr.aria-busy]="busy"
        (click)="action.emit()">
        <ion-spinner *ngIf="busy" name="crescent" aria-hidden="true"></ion-spinner>
        {{ actionLabel | t }}
    </button>
</div>
